import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { TableFooterPagination as View } from './TableFooterPagination'

export const TableFooterPagination = withStyles(styles)(View)
